import React, { useState } from 'react';
import useChat from '../../useChat';
import { makeStyles } from '@material-ui/core/styles';
import Box from '@material-ui/core/Box';
import { Formik } from 'formik';
import { BForm, BSubmit, BTextField } from 'mui-bueno';
import theme from '../../theme';

const useStyles = makeStyles(() => ({
	commentsWrapper: {
		position: 'relative',
		overflow: 'scroll',
	},
	messagesContainer: {
		flex: 1,
		minHeight: '100px',
		overflow: 'auto',
		border: '1px solid black',
		borderRadius: '7px 7px 0 0',
		borderColor: '#9a9a9a00',
	},
	sendForm: {
		position: 'relative',
		backgroundColor: theme.palette.primary.light,
		padding: '0px 0px 20px',
	},
	messagesList: {
		listStyleType: 'none',
		padding: 0,
	},
	sendMessageInput: {
		height: '50px',
		fontSize: '20px',
		padding: '15px 15px',
	},
	messageItem: {
		width: '55%',
		maxWidth: '400px',
		margin: '8px',
		padding: '0px 8px',
		wordBreak: 'break-word',
		borderRadius: '20px',
	},
	name: {
		color: 'grey',
		padding: '3px 0px 3px 5px',
	},
	time: {
		color: 'grey',
		padding: '3px 0px 3px 5px',
	},
	message: {
		color: 'white',
		padding: '15px',
		borderRadius: '10px',
	},
	myMessage: {
		marginLeft: 'auto',
		float: 'right',
	},
	myMessageColor: {
		backgroundColor: theme.palette.secondary.main,
	},
	receivedMessage: {
		float: 'left',
	},
	receivedMessageColor: {
		backgroundColor: theme.palette.primary.main
	},
	sendMessageButton: {
		width: '85%',
		margin: 'auto',
		marginTop: '15px',
	},
	gridWrapper: {
		flexGrow: 1,
	},
}));

const Comments = () => {
	const classes = useStyles();
	const { messages, sendMessage } = useChat();
	const [initialValues, setInitialValues] = useState({
		name: '',
		message: '',
	});

	// const handleNewMessageChange = (event) => {
	// setNewMessage(event.target.value);
	// };

	const handleSubmit = (data: any, actions: any) => {
		sendMessage(data);
		actions.resetForm({
			name: '',
			message: '',
		});
	};

	return (
		<>
			<Box className={`${classes.commentsWrapper}`}>
                <Box className={`${classes.sendForm}`}>
					<Formik
						initialValues={initialValues}
						onSubmit={handleSubmit}
						validateOnChange={false}
						validateOnBlur={false}
					>
						<BForm>
							<BTextField
								name='message'
								full
                                label='Enter Comment'
								// placeholder='Write message...'
								className={`${classes.sendMessageInput}`}
							/>
							<BSubmit
								full
								className={classes.sendMessageButton}
								name='submit'
							>
								Send Comment
							</BSubmit>
						</BForm>
					</Formik>
				</Box>
				<Box className={`${classes.messagesContainer}`}>
					<ol className={`${classes.messagesList}`}>
						{messages.map((message: any, i: any) => (
							<>
								{message.ownedByCurrentUser ? (
									<li
										key={i}
										className={`${classes.messageItem} ${classes.myMessage}`}
									>
										<Box className={`${classes.name}`}>
											{message.name} at {message.time}
										</Box>
										<Box className={`${classes.message} ${classes.myMessageColor}`}>
											{message.message}
										</Box>
									</li>
								) : (
									<li
										key={i}
										className={`${classes.messageItem} ${classes.receivedMessage}`}
									>
										<Box className={`${classes.name}`}>
											{message.name} at {message.time}
										</Box>
										<Box className={`${classes.message} ${classes.receivedMessageColor}`}>
											{message.message}
										</Box>
									</li>
								)}
							</>
						))}
					</ol>
				</Box>
			</Box>
		</>
	);
};

export default Comments;
